/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useContext, useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import SignInBgDesktop from "assets/Images/signin-backround.png";
import { LoaderContext } from "components/context/LoaderContext";
import clsx from "clsx";
import { Helmet } from "react-helmet-async";

import { MAGNETIQ_LINKS } from "../../constants";
import SafariAllowPopupInfoModal from "./SafariAllowPopupInfoModal";
import { CloseIcon, InstagramIcon, MagnetiqLogo, TwitterIcon } from "../../components/atoms/Icon";
import SignInForm from "./SignInForm";

export default function SignIn() {
  const [isCloseButtonVisible, setIsCloseButtonVisible] = useState(false);
  const [formType, setFormType] = useState<0 | 1 | 2 | 3>(1); // 0- signin, 1- signup, 2- reset password, 3- Otp Sent
  const { loading, setLoading } = useContext(LoaderContext);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (loading) {
      timeout = setTimeout(() => {
        setIsCloseButtonVisible(loading);
      }, 5000);
    }
    return () => clearTimeout(timeout);
  }, [loading]);

  const closeHandler = () => {
    setIsCloseButtonVisible(false);
    setLoading(false);
  };

  const [safariModalOpen, setSafariModalOpen] = useState(false);

  // const SignUpBtnClassName =
  //   "flex w-full items-center justify-between rounded-md p-4 font-bold md:p-6 2xl:px-6 2xl:py-5 hover:scale-105 duration-300 ease-out";

  const isSafariBrowser = useRef(false);

  // check browser is safari or not
  if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) {
    isSafariBrowser.current = true;
  }

  return (
    <>
      <Helmet>
        <title>Sign In - MAGNETIQ</title>
      </Helmet>
      <SafariAllowPopupInfoModal open={safariModalOpen} closeModal={() => setSafariModalOpen(false)} />
      <button
        type="button"
        className={clsx(
          "right-12 top-8 z-[101] rounded-full bg-white p-4",
          isCloseButtonVisible && loading ? "fixed" : "hidden",
        )}
        onClick={closeHandler}
      >
        <CloseIcon className="h-4 w-4 text-gray-700" />
      </button>
      <div
        style={{ backgroundImage: `url(${SignInBgDesktop})` }}
        className="secondary-scrollbar bg-[lenght:200%] fixed left-0 top-0 flex h-screen w-screen flex-col items-center justify-between overflow-auto bg-primary bg-no-repeat pt-10 lg:bg-contain"
      >
        <div />
        <div className="flex flex-col gap-2 px-6 sm:max-w-[550px] md:gap-4 md:py-10">
          <MagnetiqLogo className="w-64 2xl:w-80" />
          <p className="md:text-auto text-[15px] text-white caret-transparent">
            Changing the way brands and consumers interact. Forever!
          </p>
          {/* {formType === 0 && (
                <div className="rounded-lg border-1 border-dashed border-accent border-opacity-60 bg-slate-50 bg-opacity-10 py-4 pl-3 pr-4 font-satoshi text-xxs leading-snug tracking-wide text-neutral-400">
                  <p>
                    Note: We are moving to a newer, faster and safer Sign-In / Sign-Up flow. Existing user&apos;s will
                    have to click on{" "}
                    <span className="font-black tracking-wider text-accent text-opacity-80">
                      {" "}
                      &lsquo;Forgot Password?&rsquo;{" "}
                    </span>{" "}
                    below and create a new password by verifying their email address.
                  </p>
                </div>
              )} */}

          {/* <div
                className={`-mt-2 flex items-center gap-2 rounded-md bg-[#1D2018] px-3 py-4 2xl:w-[80%] ${
                  !isSafariBrowser.current && "lg:hidden"
                }`}
              >
                <ExclamationTriangleIcon className="h-5 w-5  text-[#FF9B00] " />
                <div className="flex flex-wrap items-center gap-1 text-[12px] text-[#FF9B00] lg:text-[15px]">
                  <p>You must enable pop-ups to signup/login.</p>
                  <div
                    tabIndex={0}
                    onKeyDown={() => {}}
                    role="button"
                    className="flex cursor-pointer items-center gap-x-1"
                    onClick={() => navigateToPopUpsLink()}
                  >
                    <p className="border-b border-[#FF9B00] pb-[1px]">Click Here</p>
                    <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                  </div>
                </div>
              </div> */}
          <SignInForm formType={formType} setFormType={setFormType} />
        </div>
        <div className="flex flex-row justify-between self-stretch bg-primary p-6 font-sora text-sm font-semibold text-[#9b9fa4] lg:items-center">
          <div className="flex items-center gap-6 lg:gap-5">
            <a href={MAGNETIQ_LINKS.TWITTER_LINK} target="_blank" rel="noreferrer">
              <div className="flex cursor-pointer items-center space-x-2">
                <TwitterIcon />
                <div className="hidden md:block">TWITTER</div>
              </div>
            </a>
            <a href={MAGNETIQ_LINKS.INSTAGRAM_LINK} target="_blank" rel="noreferrer">
              <div className="flex cursor-pointer items-center space-x-2">
                <InstagramIcon />
                <div className="hidden md:block">INSTAGRAM</div>
              </div>
            </a>
          </div>
          <div className="flex gap-3 md:gap-5 ">
            <Link to={MAGNETIQ_LINKS.TERMS_OF_SERVICE_LINK} target="_blank">
              Terms Of Service
            </Link>
            <Link to={MAGNETIQ_LINKS.PRIVACY_POLICY_LINK} target="_blank">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
